import React, { CSSProperties, useState } from "react";

import { Icon, Input, InputProps } from "semantic-ui-react";

type PasswordRecheckType = {
  id?: string;
  className?: string;
  borderRadius: CSSProperties["borderRadius"];
  error?: boolean;
  fluid?: boolean;
  password: string;
  placeholder?: string;
  size?: InputProps["size"];
  style?: CSSProperties;
  setPassword: (password: string) => void;
};

const PasswordRecheck = (props: PasswordRecheckType) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Input
      ref={(ref: any) => {
        if (ref && props.borderRadius) {
          ref.inputRef.current.style.borderRadius = props.borderRadius;
        }
      }}
      style={props.style}
      id={props.id}
      className={props.className}
      error={props.error}
      fluid={props.fluid}
      placeholder={props.placeholder || "จำเป็นต้องระบุรหัสผ่าน"}
      size={props.size}
      type={showPassword ? "text" : "password"}
      value={props.password}
      onChange={(event, data) => {
        props.setPassword(data.value);
      }}
      icon={
        <Icon
          disabled={!props.password}
          name={showPassword ? "eye" : "eye slash"}
          link
          onClick={() => {
            setShowPassword(!showPassword);
          }}
        />
      }
    />
  );
};

export default PasswordRecheck;
